module.exports = __webpack_public_path__ + "img/if-chart-histogram-alt.1634f790.svg";